import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';

import QRCode from 'qrcode.react';

import logo from '../assets/icon/logo_geren_icon.png';
import dhsLogo from '../assets/icon/dhs_logo_50_50.PNG';
import bg from '../assets/img/dbj_geren_icon.png';
import print from '../assets/icon/dayin_geren_icon.png';

import { BoxDiv } from './box';
import { TextButton } from './button';
import { queryObject } from '../util';

const Container = styled.div`
  height: 590px;
  background: url(${bg});
`;

const LogoLine = styled.div`
  padding: 27px 42px;
  font-size: 16px;
  color: white;
  line-height: 35px;
  
  & > * {
    vertical-align: middle;
  }
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: top;
  justify-content: space-around;
  padding: 0 8%;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ScreenOnlyColumn = styled(Column)`
  @media print {
    display: none;
  }
`;

const QRWrapper = styled.div`
  background: white;
  width: 154px;
  height: 154px;
  padding: 13px;
`;

const PrintIconWrapper = styled.div`
  background: none;
  width: 154px;
  height: 154px;
  padding: 20px;
  
  img {
    width: 117px;
  }
`;

const Info = styled.div`
  color: white;
  font-size: 20px;
  width: 154px;
  text-align: center;
  margin-top: 15px;
`;

const PrintButton = styled(TextButton)`
  border: 2px solid white;
  height: 40px;
  border-radius: 20px;
  margin-top: 15px;
  font-size: 22px;
`;

const ReportId = styled.div`
  color: white;
  font-size: 22px;
  text-align: right;
  padding: 20px;
`;

class ReportFooter extends Component {
  constructor() {
    super();
    this.doPrint = this.doPrint.bind(this);
  }

  doPrint() {
    if (window.zhiyun) {
      window.zhiyun.print();
    } else if (window.print) {
      window.print();
    }
  }

  render() {
    const { source = '' } = queryObject();
    return (
      <BoxDiv style={{ paddingTop: '60px' }}>
        <Container>
          <LogoLine>
            <img
              src={source === 'dhs' ? dhsLogo : logo}
              alt='logo'
              style={{
                height: '35px',
                marginRight: '0.8em',
            }} />{ source === 'dhs' ? '黑龙江鼎恒升药业有限公司' : '上海祉云医疗科技有限公司' }
          </LogoLine>
          <Row>
            <Column>
              <QRWrapper>
                {this.props.shareUrl ? <QRCode value={this.props.shareUrl} /> : null}
              </QRWrapper>
              <Info>
                手机扫描二维码<br />
                获取报告
              </Info>
            </Column>
            <ScreenOnlyColumn>
              <PrintIconWrapper>
                <img src={print} alt='print-button' />
              </PrintIconWrapper>
              <PrintButton onClick={this.doPrint}>一键打印</PrintButton>
            </ScreenOnlyColumn>
          </Row>
          <ReportId>报告编号：{this.props.reportId}</ReportId>
        </Container>
      </BoxDiv>
    );
  }
}

ReportFooter.propTypes = {
  shareUrl: PropTypes.string.isRequired,
  reportId: PropTypes.string.isRequired,
};

ReportFooter.defaultProps = {};

export default ReportFooter;



// WEBPACK FOOTER //
// ./src/components/report-footer.jsx